/**
 * Combines multiple strings into a single string, trimming whitespace from each part
 * and filtering out empty strings. Parts are joined with a single space.
 * @param {...string} parts - Variable number of string arguments to combine
 * @returns {string} Combined string with trimmed parts joined by spaces, or empty string if all parts are empty
 * @example
 * combineStrings('  John  ', '  Doe  ') // Returns: 'John Doe'
 * combineStrings('John', '', 'Doe') // Returns: 'John Doe'
 * combineStrings('  ', '  ') // Returns: ''
 * combineStrings('First', 'Middle', 'Last') // Returns: 'First Middle Last'
 */
export const combineStrings = (...parts) => {
  return parts
    .map((part) => (part || '').trim())
    .filter((part) => part.length > 0)
    .join(' ')
}
